import { render, staticRenderFns } from "./ScreenshotsTracking.vue?vue&type=template&id=1b375e78&"
import script from "./ScreenshotsTracking.vue?vue&type=script&lang=js&"
export * from "./ScreenshotsTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports